import { useQuery } from '@tanstack/react-query';
import { fetchAuditLogs, AuditLogParams } from '@/services/platform-admin-api';

const PLATFORM_AUDIT_LOGS_KEY = ['platform', 'audit-logs'];

export function usePlatformAuditLogs(params: AuditLogParams = {}) {
  return useQuery({
    queryKey: [...PLATFORM_AUDIT_LOGS_KEY, params],
    queryFn: () => fetchAuditLogs(params),
    staleTime: 15_000,
  });
}
